import React from 'react';

const BookingsFill = (props: React.ComponentProps<'svg'>) => {
    return (
        <svg
            {...props}
            xmlns={'http://www.w3.org/2000/svg'}
            width={'1rem'}
            height={'1rem'}
            viewBox={'0 0 16 16'}
            fill={'none'}
        >
            <path
                d={
                    // eslint-disable-next-line max-len
                    'M7.5 3.02201C6.4554 2.35292 5.24051 1.99817 4 2.00001C3.26199 1.99925 2.52927 2.12438 1.83333 2.37001C1.73586 2.40447 1.65147 2.4683 1.59177 2.55271C1.53208 2.63712 1.50001 2.73796 1.5 2.84134V12.3413C1.50001 12.4213 1.51921 12.5001 1.55599 12.5712C1.59276 12.6422 1.64604 12.7034 1.71135 12.7495C1.77666 12.7957 1.8521 12.8255 1.93132 12.8365C2.01055 12.8475 2.09126 12.8393 2.16667 12.8127C2.75556 12.605 3.37556 12.4992 4 12.5C5.33 12.5 6.54867 12.9713 7.5 13.7573V3.02201ZM8.5 13.7573C9.48427 12.9428 10.7224 12.498 12 12.5C12.644 12.5 13.26 12.6107 13.8333 12.8133C13.9088 12.84 13.9896 12.8482 14.0688 12.8372C14.1481 12.8262 14.2236 12.7963 14.2889 12.75C14.3542 12.7038 14.4075 12.6425 14.4442 12.5714C14.481 12.5003 14.5001 12.4214 14.5 12.3413V2.84134C14.5 2.73796 14.4679 2.63712 14.4082 2.55271C14.3485 2.4683 14.2641 2.40447 14.1667 2.37001C13.4707 2.12438 12.738 1.99925 12 2.00001C10.7595 1.99817 9.5446 2.35292 8.5 3.02201V13.7573Z'
                }
                fill={'currentColor'}
            />
        </svg>
    );
};
export default BookingsFill;
